import request from './request.js';
import {requestbody} from './request.js'
import {requestBlob} from './request.js'

//结果展示分页查询
export async function xxtjb_query (params = {
}) {
    return await requestbody('/dataDisposeCenter/adjust/query', 'post', params)
}
//结果展示分页查询
export async function xxtjb_detail_query (params = {
}) {
    return await requestbody('/dataDisposeCenter/adjust/query/detail', 'post', params)
}
//修改remark
export async function xxtjb_detail_update_remark (params = {
}) {
    return await requestbody('/dataDisposeCenter/adjust/updateReamrk', 'post', params)
}

//结果展示分页查询
export async function xxtjb_get_fpimage (params = {
}) {
return await requestBlob('dataDisposeCenter/adjust/getFapinfoImage', 'get', params)
}